module.exports = "/_next/static/images/ThePayoff-sm@2x-fac2872182556bd5c4e6ed1eb03c71ec.webp";